module.exports = __webpack_public_path__ + "img/blog-dark.a0ac25a0.svg";